import { Modal } from '@core/component';
import { ESize } from '@core/type';

import { Form } from './Form';
import { ModalSpotlightProps } from './interface-modal-spotlight';

export const ModalSpotlight = ({ isOpen, onCloseModal, onSuccess }: ModalSpotlightProps) => {
  return (
    <Modal isOpen={isOpen} onCloseModal={onCloseModal} size={ESize.MD}>
      <Form onCloseModal={onCloseModal} onSuccess={onSuccess} />
    </Modal>
  );
};
